var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "booking-section",
    {
      attrs: {
        id: "flight-results",
        title: _vm.sectionTitle,
        collapsed: _vm.moduleCollapsed,
      },
      on: { "section-clicked": _vm.sectionClicked },
    },
    [
      _vm.loaded
        ? _c("div", [
            _c(
              "div",
              {
                staticClass: "reveal",
                attrs: { id: "flight-plan-overlay", "data-reveal": "" },
              },
              [
                _vm.flightPlanLoading
                  ? _c("loader", {
                      attrs: {
                        title: "Flugplan wird geladen",
                        details: "Einen Moment bitte",
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "flight-plan-inner" }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "close-button",
                    attrs: { "data-close": "", type: "button" },
                  },
                  [_vm._v("Fenster schließen ( x )")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            !_vm.moduleCollapsed
              ? _c(
                  "div",
                  {
                    staticClass:
                      "filter--main filter--inline spacer-small controlled fadeIn animationEnd",
                    attrs: { "data-animation": "fadeIn" },
                  },
                  [
                    _c("div", { staticClass: "expanded row" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "column expanded row align-spaced filter--main__option__wrapper",
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "small-12 medium-expand column filter--main__option",
                              attrs: { id: "optionsFilter" },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "row",
                                  on: {
                                    click: function ($event) {
                                      return _vm.toggleFilterItem(
                                        "optionsFilter"
                                      )
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "filter--main__option__title",
                                    },
                                    [
                                      _c("label", [_vm._v("Optionen")]),
                                      _vm._v(" "),
                                      _c("div", {
                                        staticClass:
                                          "filter--main__option__value",
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.formattedFilterDisplayOptions()
                                          ),
                                        },
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "arrow" }),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "filter--main__option__dropdown",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "expanded row align-middle spacer-small",
                                    },
                                    [
                                      _c("label", [_vm._v("Flugklassen")]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "flight-filter-checkboxes row",
                                        },
                                        _vm._l(
                                          _vm.cabinTypes,
                                          function (cabin) {
                                            return _c(
                                              "div",
                                              {
                                                class: `flight-filter-checkbox column small-12 flight-filter--${!_vm.carrierAirportFilterSelected(
                                                  "cabin_type",
                                                  cabin
                                                )}`,
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.toggleCarrierAirportFilter(
                                                      "cabin_type",
                                                      cabin
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "checkbox-icon",
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "checkbox-icon--marker",
                                                      },
                                                      [_vm._v("X")]
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "checkbox-label",
                                                  },
                                                  [_vm._v(_vm._s(cabin) + " ")]
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "column small-12" },
                                        [
                                          _c("label", [_vm._v("max: Stops")]),
                                          _vm._v(" "),
                                          _c("vue-slider", {
                                            attrs: {
                                              min: 0,
                                              max: 2,
                                              tooltip: "always",
                                              "tooltip-placement": "bottom",
                                              "tooltip-formatter":
                                                _vm.sliderStopsFormatter,
                                            },
                                            model: {
                                              value: _vm.flightFilter.stops,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.flightFilter,
                                                  "stops",
                                                  $$v
                                                )
                                              },
                                              expression: "flightFilter.stops",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "filter--main__border" }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "small-12 medium-expand column filter--main__option",
                              attrs: { id: "airlineAirport" },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "row",
                                  on: {
                                    click: function ($event) {
                                      return _vm.toggleFilterItem(
                                        "airlineAirport"
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("div", [
                                    _c("label", [_vm._v("Airlines/Airports")]),
                                    _vm._v(" "),
                                    _c("div", {
                                      staticClass:
                                        "filter--main__option__value",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.formattedFilterDisplayAirlineAirport()
                                        ),
                                      },
                                    }),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "arrow" }),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "filter--main__option__dropdown",
                                },
                                [
                                  _c("div", { staticClass: "expanded row" }, [
                                    _c(
                                      "div",
                                      { staticClass: "column small-12" },
                                      [
                                        _c("label", [_vm._v("Airlines")]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "airline-filter-icons",
                                          },
                                          _vm._l(
                                            _vm.availableCarriers,
                                            function (carrier) {
                                              return _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "airline-filter-icon",
                                                  class: `airline-filter-icon airline-filter--${!_vm.carrierAirportFilterSelected(
                                                    "carrier",
                                                    carrier.code
                                                  )}`,
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.toggleCarrierAirportFilter(
                                                        "carrier",
                                                        carrier.code,
                                                        carrier.name
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("span", {
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        carrier.logo
                                                      ),
                                                    },
                                                  }),
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "column small-12" },
                                      [
                                        _c("label", [
                                          _vm._v("Umsteige-Airports"),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "flight-filter-checkboxes",
                                          },
                                          _vm._l(
                                            _vm.availableAirports,
                                            function (airport) {
                                              return _c(
                                                "div",
                                                {
                                                  class: `flight-filter-checkbox flight-filter--${!_vm.carrierAirportFilterSelected(
                                                    "airport",
                                                    airport.code
                                                  )}`,
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.toggleCarrierAirportFilter(
                                                        "airport",
                                                        airport.code,
                                                        airport.name
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "checkbox-icon",
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "checkbox-icon--marker",
                                                        },
                                                        [_vm._v("X")]
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "checkbox-label",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(airport.name) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "filter--main__border" }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "small-12 medium-expand column filter--main__option",
                              attrs: { id: "flightTime" },
                              on: {
                                click: function ($event) {
                                  return _vm.toggleFilterItem("flightTime")
                                },
                              },
                            },
                            [
                              _c("div", { staticClass: "row" }, [
                                _c("div", [
                                  _c("label", [_vm._v("Flugzeit/Dauer:")]),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass: "filter--main__option__value",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.formattedFilterDisplayFlightTime()
                                      ),
                                    },
                                  }),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "arrow" }),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "filter--main__option__dropdown",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "expanded row align-middle spacer-small",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "column small-12 spacer",
                                        },
                                        [
                                          _c("label", [
                                            _vm._v("Abflugzeit Anreise"),
                                          ]),
                                          _vm._v(" "),
                                          _c("vue-slider", {
                                            attrs: {
                                              min: 0,
                                              max: 24,
                                              tooltip: "always",
                                              "tooltip-placement": "bottom",
                                              "tooltip-formatter":
                                                _vm.sliderTimeFormatter,
                                            },
                                            model: {
                                              value:
                                                _vm.flightFilter
                                                  .departure_hour_out,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.flightFilter,
                                                  "departure_hour_out",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "flightFilter.departure_hour_out",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "column small-12 spacer",
                                        },
                                        [
                                          _c("label", [
                                            _vm._v("Abflugzeit Abreise"),
                                          ]),
                                          _vm._v(" "),
                                          _c("vue-slider", {
                                            attrs: {
                                              min: 0,
                                              max: 24,
                                              tooltip: "always",
                                              "tooltip-placement": "bottom",
                                              "tooltip-formatter":
                                                _vm.sliderTimeFormatter,
                                            },
                                            model: {
                                              value:
                                                _vm.flightFilter
                                                  .departure_hour_in,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.flightFilter,
                                                  "departure_hour_in",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "flightFilter.departure_hour_in",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "column small-12" },
                                        [
                                          _c("label", [
                                            _vm._v("max. Flugdauer / h "),
                                          ]),
                                          _vm._v(" "),
                                          _c("vue-slider", {
                                            attrs: {
                                              min: _vm.minFlightHours,
                                              max: _vm.maxFlightHours,
                                              tooltip: "always",
                                              "tooltip-placement": "bottom",
                                              "tooltip-formatter":
                                                _vm.sliderHourFormatter,
                                            },
                                            model: {
                                              value:
                                                _vm.flightFilter.flight_hours,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.flightFilter,
                                                  "flight_hours",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "flightFilter.flight_hours",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _vm.anyFiltersSet
                            ? _c("div", { staticClass: "filter--main__border" })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.anyFiltersSet
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "small-12 medium-expand column filter--main__option",
                                  attrs: { id: "filterReset" },
                                },
                                [
                                  _c("div", { staticClass: "row" }, [
                                    _c("div", [
                                      _c(
                                        "a",
                                        {
                                          staticClass: "cta",
                                          on: {
                                            click: function ($event) {
                                              return _vm.resetFilter()
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "foundicon-remove",
                                          }),
                                          _vm._v(" Filter löschen\n      "),
                                        ]
                                      ),
                                    ]),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                        ]
                      ),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "booking__flight__select__wrapper",
                staticStyle: { display: "block" },
              },
              [
                _c("div", { staticClass: "booking__flight__select row" }, [
                  _c(
                    "div",
                    {
                      class: `column small-12 medium-6 booking__flight__select__option ${
                        _vm.flightFilter.sortOption == "flight_hours"
                      }`,
                      on: {
                        click: function ($event) {
                          return _vm.setSortOption("flight_hours")
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "booking__flight__select__option__title",
                        },
                        [
                          _vm.flightFilter.sortOption == "flight_hours"
                            ? _c("img", {
                                attrs: {
                                  src: "/images/icons_svg/checkbox-icon.svg",
                                },
                              })
                            : _vm._e(),
                          _vm._v("\n      Schnellste\n    "),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "booking__flight__select__option__price text-xsmall",
                        },
                        [
                          _vm._v(
                            "ab " +
                              _vm._s(_vm.result.fastest_price_pp_euro) +
                              " EUR p.P."
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      class: `column small-12 medium-6 booking__flight__select__option last ${
                        _vm.flightFilter.sortOption == "price_factor"
                      }`,
                      on: {
                        click: function ($event) {
                          return _vm.setSortOption("price_factor")
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "booking__flight__select__option__title",
                        },
                        [
                          _vm.flightFilter.sortOption == "price_factor"
                            ? _c("img", {
                                attrs: {
                                  src: "/images/icons_svg/checkbox-icon.svg",
                                },
                              })
                            : _vm._e(),
                          _vm._v("\n      Günstigste\n    "),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "booking__flight__select__option__price text-xsmall",
                        },
                        [
                          _vm._v(
                            "ab " +
                              _vm._s(_vm.result.cheapest_price_pp_euro) +
                              " EUR p.P."
                          ),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "booking__flight",
                attrs: { id: "flight-package-results" },
              },
              _vm._l(_vm.sortedFlightResults, function (result) {
                return _c(
                  "div",
                  {
                    staticClass: "row booking-element",
                    class: { "is-preferred": result.flight_meta.preferred },
                  },
                  [
                    result.flight_meta.preferred
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "column small-12 medium-12 large-12 flight-preferred-bar",
                          },
                          [_vm._v("LUXURY DREAMS EMPFEHLUNG")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "column small-12 medium-12 large-12" },
                      [
                        _c("flight-result", {
                          attrs: { flightResult: result.flight_meta },
                          on: {
                            "show-flight-plan": function ($event) {
                              return _vm.showFlightPlan(result)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "column small-12 large-8 booking__flight__price text-xsmall",
                      },
                      _vm._l(result.sub_results, function (sub_price) {
                        return _c("div", { staticClass: "spacer-small" }, [
                          _vm._v("\n        Preis p.P.: ca.\n        "),
                          _c("b", [_vm._v(_vm._s(sub_price.price_display))]),
                          _vm._v(
                            "\n        inkl. Aufenthalt, Flug mit " +
                              _vm._s(sub_price.free_bags) +
                              " und weitere Leistungen"
                          ),
                          _c("sup", [_vm._v("*")]),
                          _vm._v(" "),
                          _c("div", { staticClass: "small metainfo" }, [
                            _vm._v(_vm._s(sub_price.name)),
                          ]),
                        ])
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "column small-12 large-4" }, [
                      _c("div", { staticClass: "text-right" }, [
                        _c(
                          "a",
                          {
                            staticClass: "cta btn btn-info btn-xs",
                            on: {
                              click: function ($event) {
                                return _vm.proceedBooking(result)
                              },
                            },
                          },
                          [
                            _c("img", {
                              staticClass: "svg-icon",
                              attrs: {
                                src: "/images/icons_svg/flight-icon.svg",
                              },
                            }),
                            _vm._v("\n          Buchen: "),
                            _c("b", [_vm._v(_vm._s(result.total))]),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "spacer-small text-right" }, [
                        _c("br"),
                        _c("span", { staticClass: "metainfo text-xsmall" }, [
                          _vm._v(
                            "Gesamtpreis für alle Personen inkl. aller Leistungen"
                          ),
                        ]),
                      ]),
                    ]),
                  ]
                )
              }),
              0
            ),
          ])
        : _c("loader", {
            attrs: {
              title: "Ihre Flugauswahl wird geladen",
              details: "Einen Moment bitte",
            },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }